import { cn } from 'utils/bem';

export const dropdownMenu = cn('dropdown-menu');
